/**
 * Fragebogen-Sicht des caseStore (Kundenfeedback Kanzlei Polz 25.10.2026, VIII).
 *
 * Der Fragebogen ist die Fassung des Kunden, die Akte die der Kanzlei. Lädt der
 * Fragebogen (Seite /fragebogen/:id oder Fragebogen in der Akte) mit
 * `?view=fragebogen`, liefert das Backend Externen ihre eigenen, noch nicht
 * übernommenen Angaben statt abweichender Aktenwerte. Gespeichert wird dann
 * immer mit `?source=fragebogen`: Abweichende Angaben warten so als
 * Abweichung auf die Kanzlei, statt die Akte zu überschreiben. Ladeart und
 * Speicherquelle hängen bewusst am selben Merker – sonst könnten überlagerte
 * Werte als Akten-Bearbeitung zurückgeschrieben werden.
 */

export const QUESTIONNAIRE_SOURCE = "fragebogen";

/** Pfad der Fragebogen-Seite (/fragebogen/:idCase). */
export function isQuestionnaireRoutePath(path: string | null | undefined): boolean {
  return typeof path === "string" && /^\/fragebogen(\/|$)/.test(path);
}

/** Aktueller Browser-Pfad (ohne window: leer). */
export function currentPath(): string {
  return typeof window !== "undefined" && window.location ? window.location.pathname : "";
}

/** Hängt `name=value` an einen Endpunkt an (vorhandene Query bleibt). */
export function appendQuery(endpoint: string, name: string, value: string): string {
  const delimiter = endpoint.includes("?") ? "&" : "?";
  return `${endpoint}${delimiter}${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
}

/** `?view=fragebogen` für das Laden in der Fragebogen-Sicht. */
export function withQuestionnaireView(endpoint: string, active: boolean): string {
  return active ? appendQuery(endpoint, "view", QUESTIONNAIRE_SOURCE) : endpoint;
}

/**
 * `?source=fragebogen` für Speicherungen aus der Fragebogen-Sicht. Eine
 * ausdrückliche Quelle (z. B. `source=akte`) bleibt unangetastet.
 */
export function withQuestionnaireSource(endpoint: string, active: boolean): string {
  if (!active || /[?&]source=/.test(endpoint)) return endpoint;
  return appendQuery(endpoint, "source", QUESTIONNAIRE_SOURCE);
}
